import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Location} from '@angular/common';
import {SharedImports} from '@shared/shared-imports';
import {Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PaymentMethodModel} from '@app/models/payment-methods.model';
import {UserSOICampaignDonationModel} from '@app/models/user-soi-campaign-donation.model';
import {SOICampaignModel} from '@app/models/soi-campaigns.model';

@Component({
  selector: 'app-campaign-page-2',
  templateUrl: './page-2-billing.component.html',
  styleUrls: ['./page-2-billing.component.scss'],
  imports: [
    SharedImports
  ]
})

export class Page2BillingComponent implements OnInit, OnChanges {
  mainForm: FormGroup;
  ccType: string;
  visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
  mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
  amexpRegEx = /^(?:3[47][0-9]{13})$/;
  discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
  flipped: boolean = false;
  @Output() updateData = new EventEmitter<any>();
  @Input() campaignProfile: UserSOICampaignDonationModel;
  @Output() next = new EventEmitter<any>();
  @Input() campaignId: number;
  @Input() orgCampaignDetails: SOICampaignModel;

  constructor(private router: Router, private location: Location, private formBuilder: FormBuilder) {
    this.mainForm = this.formBuilder.group({
      fullName: new FormControl(null, [Validators.required]),
      cc: new FormControl(null, [Validators.required, Validators.minLength(15), Validators.maxLength(16), Validators.pattern('^[0-9 ]*$')]),
      expMonth: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern('^[0-9]*$')]),
      expYear: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern('^[0-9]*$')]),
      verificationNumber: new FormControl(null, [Validators.required]),
      recurring: new FormControl(null)
    });
  }


  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
    this.mainForm.get('recurring').setValue(true);
    this.mainForm.get('recurring').disable();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.campaignProfile.PaymentMethod) {
      this.mainForm.get('fullName').setValue(this.campaignProfile.PaymentMethod.NameOnAccount);
      this.mainForm.get('cc').setValue(this.campaignProfile.PaymentMethod.AccountNumber);
      this.mainForm.get('expMonth').setValue(this.campaignProfile.PaymentMethod.CCExpirationMonth);
      this.mainForm.get('expYear').setValue(this.campaignProfile.PaymentMethod.CCExpirationYear);
      this.mainForm.get('verificationNumber').setValue(this.campaignProfile.PaymentMethod.CVV);
      this.mainForm.get('recurring').setValue(this.campaignProfile.PaymentMethod.Recurring);
    }
    this.initData();
  }

  initData() {
    this.mainForm.valueChanges.subscribe(data => {
      this.campaignProfile.PaymentMethod = {} as PaymentMethodModel;
      this.campaignProfile.PaymentMethod.NameOnAccount = this.mainForm.get('fullName').value;
      this.campaignProfile.PaymentMethod.AccountNumber = this.mainForm.get('cc').value;
      this.campaignProfile.PaymentMethod.CCExpirationMonth = this.mainForm.get('expMonth').value;
      this.campaignProfile.PaymentMethod.CCExpirationYear = this.mainForm.get('expYear').value;
      this.campaignProfile.PaymentMethod.CVV = this.mainForm.get('verificationNumber').value;
      this.campaignProfile.PaymentMethod.Recurring = this.mainForm.get('recurring').value;
      this.mainForm.get('cc').valueChanges.subscribe(dataUpdate => {
        dataUpdate = dataUpdate?.replaceAll(' ', '');
        if (this.visaRegEx.test(dataUpdate)) {
          this.ccType = 'Visa';
        }
        if (this.mastercardRegEx.test(dataUpdate)) {
          this.ccType = 'Mastercard';
        }
        if (this.amexpRegEx.test(dataUpdate)) {
          this.ccType = 'amex';
        }
        if (this.discovRegEx.test(dataUpdate)) {
          this.ccType = 'Discover';
        }
      });
      this.updateData.emit(this.campaignProfile);
    });
  }

  goToNextPage() {
    this.next.emit();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return !(charCode < 96 && charCode > 106);
    }
    return true;
  }

  removeSpaces(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) || charCode === 190) {
      return !(charCode < 96 && charCode > 106);
    }
    return true;
  }
}
